module.exports = __webpack_public_path__ + "img/renew.3d061345.png";